import { render, staticRenderFns } from "./LifeCoveredWidget.vue?vue&type=template&id=8d5a7a68&scoped=true"
import script from "./LifeCoveredWidget.vue?vue&type=script&lang=js"
export * from "./LifeCoveredWidget.vue?vue&type=script&lang=js"
import style0 from "./LifeCoveredWidget.vue?vue&type=style&index=0&id=8d5a7a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5a7a68",
  null
  
)

/* custom blocks */
import block0 from "./LifeCoveredWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports